const manutencao_parametros_avaliacao_parcial = [
  {
    path: "/parametros-avaliacao-parcial",
    redirect: "",
    component: () => import("@/layout/Layout.vue"),
    meta: {
      allowedPermissions: ["parametros_exame_create"],
      breadCrumb: "Informações Acadêmicas - Manutenção de Regimento",
    },
    children: [
      {
        path: "/manutencao-parametros-avaliacao-parcial/:regimentoEscolarId",
        name: "manutencao_parametros_avaliacao_parcial",
        meta: {
          allowedPermissions: ["parametros_exame_list"],
        },
        component: () =>
          import("@/views/ParametrosAvaliacao/ParametrosAvaliacaoHome.vue"),
      },
      {
        path: "/manutencao-parametros-avaliacao-parcial/novo/:regimentoEscolarId",
        name: "manutencao_parametros_avaliacao_parcial_novo",
        meta: {
          allowedPermissions: ["parametros_exame_create"],
        },
        component: () =>
          import("@/views/ParametrosAvaliacao/ParametrosAvaliacaoCad.vue"),
      },
      {
        path: "/manutencao-parametros-avaliacao-parcial/editar/:regimentoEscolarId/:id",
        name: "manutencao_parametros_avaliacao_parcial_editar",
        meta: {
          allowedPermissions: ["parametros_exame_edit"],
        },
        component: () =>
          import("@/views/ParametrosAvaliacao/ParametrosAvaliacaoEdit.vue"),
      },
    ],
  },
];

export { manutencao_parametros_avaliacao_parcial };
